import React from 'react';

import { FormSubmitButton } from '../../../components/Button/FormSubmitButton';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import { TextInputField } from '../../../components/FormCom/FormField';
import { HideableTextFormField } from '../../../components/FormCom/HideableTextFormField';
import useSignin from '../../../hooks/auth/admin/useSignin';
import {
  ISecondStepResponse,
  SignInDataType,
  signinInitialValues,
  SignInSchema,
} from '../../../models/auth/signIn.model';

const SignInForm: React.FC<{ onSecondStep?: (step: ISecondStepResponse) => void }> = ({ onSecondStep }) => {
  const { loading, signin } = useSignin(onSecondStep);

  const onSubmit = (value: SignInDataType) => {
    signin(value);
  };

  return (
    <FormComponent
      initialValues={signinInitialValues}
      schema={SignInSchema}
      onSubmit={onSubmit}
    >
      <TextInputField
        label='Email'
        name='email'
        id='email'
        type='email'
        placeholder='Email'
      />

      <HideableTextFormField
        label='Password'
        name='password'
        type='password'
        id='password'
        placeholder='Password'
      />

      <FormSubmitButton loading={loading} className='topMargin large'>
        Sign In
      </FormSubmitButton>
    </FormComponent>
  );
};

export default SignInForm;
